const STORAGE_KEY = "eternalMyAccountPermissionsSnapshot_v1";

export function loadMyAccountPermissionsSnapshot() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return parsed;
  } catch(err) {
    console.log("Error loading my account permissions snapshot", err);
    return null;
  }
}

export function saveMyAccountPermissionsSnapshot(snapshot) {
  if (!snapshot || typeof snapshot !== "object") return;
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        ...snapshot,
        updatedAt: Date.now(),
      })
    );
  } catch(err) {
    console.log("Error saving my account permissions snapshot", err);
    /* quota / private mode */
  }
}

export function clearMyAccountPermissionsSnapshot() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch(err) {
    console.log("Error clearing my account permissions snapshot", err);
    /* ignore */
  }
}
